// User account dropdown — vanilla JS, no Stimulus

function closeUserMenu() {
  const panel = document.getElementById("user-menu-panel");
  const trigger = document.getElementById("user-menu-trigger");
  if (panel) panel.classList.remove("open");
  if (trigger) trigger.setAttribute("aria-expanded", "false");
}

function openUserMenu() {
  const panel = document.getElementById("user-menu-panel");
  const trigger = document.getElementById("user-menu-trigger");
  if (panel) panel.classList.add("open");
  if (trigger) trigger.setAttribute("aria-expanded", "true");
}

// Document-level handlers registered ONCE — look up elements dynamically
// so they stay correct after the DOM is replaced.
document.addEventListener("click", function (e) {
  const panel = document.getElementById("user-menu-panel");
  const trigger = document.getElementById("user-menu-trigger");
  if (!panel || !panel.classList.contains("open")) return;
  if (!panel.contains(e.target) && e.target !== trigger) {
    closeUserMenu();
  }
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") closeUserMenu();
});

// Reset state on BFCache restore ( Turbo was removed — see
// docs/LCP_OPTIMIZATION_PLAN_2026_07_06.md §3.8). Otherwise an open
// dropdown would persist in the BFCache snapshot.
window.addEventListener("pageshow", function (event) {
  if (event.persisted) closeUserMenu();
});

function initUserMenu() {
  const trigger = document.getElementById("user-menu-trigger");
  if (!trigger) return;

  // Guard against duplicate init on the same DOM element.
  if (trigger.dataset.menuInitialized) return;
  trigger.dataset.menuInitialized = "true";

  trigger.addEventListener("click", function (e) {
    e.stopPropagation();
    const panel = document.getElementById("user-menu-panel");
    if (panel && panel.classList.contains("open")) {
      closeUserMenu();
    } else {
      openUserMenu();
    }
  });
}

document.addEventListener("DOMContentLoaded", initUserMenu);
